import { render } from "./TextAreaInput.vue?vue&type=template&id=ed7963de"
import script from "./TextAreaInput.vue?vue&type=script&lang=js"
export * from "./TextAreaInput.vue?vue&type=script&lang=js"

import "./TextAreaInput.vue?vue&type=style&index=0&id=ed7963de&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__